
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {findDOMNode} from 'react-dom'
import classnames from 'classnames'

export default class Tooltip extends React.Component {
  static propTypes = {
    x: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    y: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    bounds: PropTypes.shape({
      x: PropTypes.number,
      y: PropTypes.number,
      width: PropTypes.number,
      height: PropTypes.number
    }),
    className: PropTypes.string,
    style: PropTypes.oneOf(['default', 'blue', 'orange', 'red']),
    place: PropTypes.oneOf(['top', 'right', 'bottom', 'left', 'auto']),
    position: PropTypes.oneOf(['start', 'center', 'end']),
    align: PropTypes.oneOf(['start', 'center', 'end'])
  }

  static defaultProps = {
    style: 'default',
    align: 'center',
    place: 'top',
    position: 'center'
  }

  constructor(props) {
    super(props)
    this.state = {
      width: null,
      height: null
    }
  }

  componentDidMount() {
    this._node = findDOMNode(this)

    this.setState({
      width: this._node.clientWidth,
      height: this._node.clientHeight
    })
  }

  render() {
    const {x, y, children, className, style, place, align, position} = this.props

    if (place !== 'auto') {
      const tooltipStyle = {
        left: x,
        top: y
      }
      const classNames = classnames('tooltip',
        className,
        `is-style-${style}`,
        `is-${place}`,
        `is-align-${align}`,
        `is-position-${position}`
      )

      return (
        <div className={classNames} style={tooltipStyle}>
          <div className='tooltip_tail' />
          {children}
        </div>
      )
    } else {
      return this.renderAuto()
    }
  }

  renderAuto() {
    const {x, y, style, bounds, children} = this.props
    const {width, height} = this.state

    let top = y
    let onTheLeft = false
    let tailOffeset = 0
    if (bounds) {
      if (y + height > bounds.y + bounds.height) {
        top = bounds.y + bounds.height - height
      }
      onTheLeft = bounds.x + bounds.width - x < bounds.x + x
      tailOffeset = (y + height) - (bounds.y + bounds.height)
    }

    const tooltipStyle = {
      top,
      left: onTheLeft ? x : x,
      visibility: width === null || height === null ? 'hidden' : 'visible'
    }

    const tailStyle = {
      top: (tailOffeset > 0 ? tailOffeset : 0) + 15
    }

    const className = classnames('tooltip', {
      'is-right': !onTheLeft,
      'is-left': onTheLeft
    }, `is-style-${style}`, 'is-align-start')

    return (
      <div className={className} style={tooltipStyle}>
        <div className='tooltip_tail' style={tailStyle} />
        {children}
      </div>
    )
  }
}

export {default as TooltipTable} from './TooltipTable'
export {default as TooltipRow} from './TooltipRow'
export {default as TooltipCell} from './TooltipCell'



// WEBPACK FOOTER //
// ./client/components/Tooltip/index.js